import Vue from 'vue'
import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

import index from '@/views/index/index.vue'

import type from '@/views/index/type.vue'
import info from '@/views/index/goods-info.vue'
import confirm from '@/views/index/confirm.vue'
import login from '@/views/index/login.vue'
import pay from '@/views/index/pay.vue'
import mine from '@/views/index/mine/mine.vue'
import cart from '@/views/index/cart.vue'
import newGoods from '@/views/index/new.vue'
import special from '@/views/index/special.vue'
import seckill from '@/views/index/seckill.vue'
import brand from '@/views/index/brand.vue'
import company from '@/views/index/company.vue'
import recruitment from '@/views/index/recruitment.vue'
import newinfo from '@/views/index/newinfo.vue'
import help from '@/views/index/help/help.vue'
import recruitmentDetail from '@/views/index/recrutmentDetail.vue'
import newInfoDetail from '@/views/index/newInfoDetail.vue'
import ceshi from '@/views/index/ceshi.vue'
import ods from '@/views/index/mine/ods.vue'
import refu from '@/views/index/mine/refu.vue'
import evl from '@/views/index/mine/evl.vue'
import scoreInfo from '@/views/index/goods_score_info.vue'
import scoreConfirm from '@/views/index/score_confirm.vue'




Vue.use(Router)

export default new Router({
    scrollBehavior: () => ({ y: 0 }),
    routes: [{
            path: '/',
            name: 'index',
            component: index
        },
        {
            path: '/type',
            name: 'type',
            component: type
        },
        {
            path: '/info',
            name: 'info',
            component: info
        },
        {
            path: '/confirm',
            name: 'confirm',
            component: confirm
        },
        {
            path: '/login',
            name: 'login',
            component: login
        },
        {
            path: '/pay',
            name: 'pay',
            component: pay
        },
        {
            path: '/mine',
            name: 'mine',
            component: mine
        },
        {
            path: '/cart',
            name: 'cart',
            component: cart
        },
        {
            path: '/new',
            name: 'new',
            component: newGoods
        },
        {
            path: '/special',
            name: 'special',
            component: special
        },
        {
            path: '/seckill',
            name: 'seckill',
            component: seckill
        },
        {
            path: '/brand',
            name: 'brand',
            component: brand
        },
        {
            path: '/company',
            name: 'company',
            component: company
        },
        {
            path: '/recruitment',
            name: 'recruitment',
            component: recruitment
        },
        {
            path: '/newinfo',
            name: 'newinfo',
            component: newinfo
        },
        {
            path: '/help',
            name: 'help',
            component: help
        },
        {
            path: '/recruitmentDetail',
            name: 'recruitmentDetail',
            component: recruitmentDetail
        },
        {
            path: '/newInfoDetail',
            name: 'newInfoDetail',
            component: newInfoDetail
        },
        {
            path: '/ceshi',
            name: 'ceshi',
            component: ceshi
        },
        {
            path: '/ods',
            name: 'ods',
            component: ods
        },
        {
            path: '/refu',
            name: 'refu',
            component: refu
        },
        {
            path: '/evl',
            name: 'evl',
            component: evl
        },
        {
            path: '/scoreInfo',
            name: 'scoreInfo',
            component: scoreInfo
        },
        {
            path: '/scoreConfirm',
            name: 'scoreConfirm',
            component: scoreConfirm
        },



    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js